import { Component, OnInit } from "@angular/core";
import { CommissionService } from "app/auth/service/commission.service";
import { UtilsService } from "app/auth/service/utils.service";
import { SALES_COSTS } from "app/pages/dashboard/analytics/analytics.config";
import moment from "moment";

@Component({
  selector: "app-economic-graph",
  templateUrl: "./economic-graph.component.html",
  styleUrls: ["./economic-graph.component.scss"],
})
export class EconomicGraphComponent implements OnInit {
  public dataChart: any = null;
  dataChartColumns: any;
  chartOptions: any = SALES_COSTS;
  constructor(
    public _utilService: UtilsService,
    public _commissionService: CommissionService,
  ) {}

  async ngOnInit() {
    this._commissionService.onDetailEconomicChange.subscribe((data) => {
      this.dataChartColumns = data;
    });
    await this.initChart()
  }

  async initChart() {
    const monthNames = moment.months().map((month: string) => month[0].toUpperCase() + month.substr(1))

    const monthlyTotals = {};
    monthNames.forEach((month) => {
      monthlyTotals[month] = {
        estimated_cost: 0,
        estimated_revenue: 0,
        effective_cost: 0,
        effective_revenue: 0,
      };
    });

    this.dataChartColumns.forEach((item) => {
      const month = monthNames[item.month_value - 1];
      monthlyTotals[month].estimated_cost += this._utilService.removeDotsFromNumber(item.estimated_cost) || 0;
      monthlyTotals[month].estimated_revenue += this._utilService.removeDotsFromNumber(item.estimated_revenue) || 0;
      monthlyTotals[month].effective_cost += this._utilService.removeDotsFromNumber(item.effective_cost) || 0;
      monthlyTotals[month].effective_cost += this._utilService.removeDotsFromNumber(item.provider_cost) || 0;
      monthlyTotals[month].effective_revenue += this._utilService.removeDotsFromNumber(item.effective_revenue) || 0;
    });

    const estimateCostData = Object.values(monthlyTotals).map((total: any) => total.estimated_cost);
    const estimateProfitData = Object.values(monthlyTotals).map((total: any) => total.estimated_revenue);
    const realCostData = Object.values(monthlyTotals).map((total: any) => total.effective_cost);
    const realProfitData = Object.values(monthlyTotals).map((total: any) => total.effective_revenue);

    setTimeout(async () => {
      this.dataChart = {
        series: [
          { name: await this._utilService.translate("ESTIMATED_COST"), type: "column", data: estimateCostData },
          { name: await this._utilService.translate("EFFECTIVE_COST"), type: "column", data: realCostData },
          { name: await this._utilService.translate("ESTIMATED_REVENUE"), type: "column", data: estimateProfitData },
          { name: await this._utilService.translate("EFFECTIVE_REVENUE"), type: "column", data: realProfitData },
        ],
        xaxis: { categories: monthNames},
      };
    }, 2000)
  }
}
